export default __webpack_public_path__ + "locales/fr/EmptyTrashDialog.json?hash=c8d081e0b85f6623f490a6266faeb0f5";